<nav class="ctv-breadcrumbs" aria-label="Breadcrumb">
  <ol>
    @for (item of items; track $index; let last = $last) {
      <li>
        @if (item.link && !(last && items.length > 1)) {
          <a [routerLink]="item.link">{{ item.label }}</a>
        } @else {
          <span [attr.aria-current]="(last && items.length > 1) ? 'page' : null">{{ item.label }}</span>
        }
        @if (!last) {
          <i class="fas fa-chevron-right breadcrumb-separator"></i>
        }
      </li>
    }
  </ol>
</nav>
